module.exports = __webpack_public_path__ + "static/media/budget.930b8b7e.png";